import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducers/reducers'
import { persistStore, persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import { socketMiddleware } from './middleware/socket';

const storageConfig = {
    key: 'root',
    storage: storageSession,
    blacklist: [],
}
const myPersistReducer = persistReducer(storageConfig, rootReducer);
export const store = createStore(myPersistReducer, applyMiddleware(thunk, socketMiddleware()))
export const persistor = persistStore(store);
